import template from './reset-password.html';
import controller from './reset-password.controller';

let resetPasswordComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default resetPasswordComponent;
